<template>
    <modal
        name="productos-a-validar"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="productos-a-validar"
        :adaptive="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Listado de productos a validar</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <ContentOrLoading>
                <template v-if="!loading">
                    <ProductosComponent
                        v-if="productos.length"
                        :productos="productos"
                        :qr_code="qr_code"
                        @confirm="validarProductos"
                        @close="close"
                    />
                    <div class="alert alert-info m-4" v-else>
                        <b>No hay productos a validar</b>
                    </div>
                </template>
            </ContentOrLoading>
        </div>
    </modal>
</template>

<script>
    import ProductosComponent from "../ProductosComponent.vue";

    export default {
        props: ["productos", "qr_code"],
        data() {
            return {
                loading: false
            };
        },
        methods: {
            validarProductos(productosSeleccionados) {
                this.$emit("validarProductos", productosSeleccionados, "productos-a-validar");
            },
            close() {
                this.$emit("close", "productos-a-validar");
            }
        },
        components: {
            ProductosComponent
        }
    };
</script>
